import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UpdateThemeDirective } from '../../layout/directives/update-theme.directive';
import { PlayerThemeAssetDirective } from './directives/player-theme-asset.directive';
import { ThemeAssetDirective } from './directives/theme-asset.directive';

@NgModule({
  declarations: [
    ThemeAssetDirective,
    PlayerThemeAssetDirective,
    UpdateThemeDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ThemeAssetDirective,
    PlayerThemeAssetDirective,
    UpdateThemeDirective,
  ],
})
export class ThemeModule { }
